import React, { useState, useEffect, useContext } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Tabs, Tab, Container, ListGroup, ListGroupItem, Accordion, Badge, Button, Form, Row, Col } from 'react-bootstrap';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { AppContext } from '../Context';
import NavbarGlobal from './NavbarGlobal';
import { db as appDb } from '../firebase/firebase';

const RegistroDePracticas = () => {
  const { id } = useParams();
  const [evaluaciones, setEvaluaciones] = useState([]);
  const [key, setKey] = useState('');
  const [userName, setUserName] = useState('');
  const db = appDb;
  const { currentUser } = useContext(AppContext); // Usa AppContext para obtener currentUser
  const [filtroModulo, setFiltroModulo] = useState('');
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');
  const [mostrarSinNivel, setMostrarSinNivel] = useState(false);


  useEffect(() => {
    const obtenerEvaluaciones = async () => {
      const q = query(collection(db, "evaluaciones"), where("userId", "==", id));
      const querySnapshot = await getDocs(q);
      const datos = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setEvaluaciones(datos);
      const orden = ['Basico', 'Intermedio', 'Avanzado'];
      const niveles = Array.from(new Set(datos.map(e => e.nivel))).filter(n => orden.includes(n));
      niveles.sort((a,b) => orden.indexOf(a) - orden.indexOf(b));
      if (niveles.length && !key) setKey(niveles[0]);
    };
  
    if (currentUser && id) {
      obtenerEvaluaciones();
    }
  }, [id, currentUser, db]);
  

  const renderRespuestasTable = (ev) => {
    const filas = [];
    const isImgUrl = (val) => typeof val === 'string' && (/\.(png|jpe?g|gif|webp|svg)$/i.test(val) || val.includes('firebasestorage.googleapis.com'));
    const pushPar = (label, val, key) => (
      <tr key={key}>
        <td className="text-muted" style={{ width: '35%' }}>{label}</td>
        <td>
          {isImgUrl(val) ? (
            <Button as="a" href={val} target="_blank" rel="noopener noreferrer" size="sm" variant="outline-secondary">Ver</Button>
          ) : Array.isArray(val) ? (
            val.join(', ')
          ) : typeof val === 'object' && val !== null ? (
            Object.entries(val).map(([kk, vv], i) => (
              <div key={`${key}-${i}`}>{`${kk}: ${Array.isArray(vv) ? vv.join(', ') : String(vv)}`}</div>
            ))
          ) : (
            String(val)
          )}
        </td>
      </tr>
    );
    if (ev?.respuestas && typeof ev.respuestas === 'object' && !Array.isArray(ev.respuestas)) {
      Object.entries(ev.respuestas).forEach(([k, v], idx) => {
        filas.push(pushPar(k, v, `resp-obj-${idx}`));
      });
    } else if (Array.isArray(ev?.respuestas)) {
      ev.respuestas.forEach((v, idx) => {
        filas.push(pushPar(`Respuesta ${idx + 1}`, v, `resp-arr-${idx}`));
      });
    } else if (typeof ev?.respuesta !== 'undefined') {
      filas.push(pushPar('Respuesta', ev.respuesta, 'respuesta-unica'));
    }
    const omit = new Set(['id','userId','nombre','nivel','modulo','tipo','createdAt','pregunta','respuestas','respuesta']);
    Object.entries(ev)
      .filter(([k, v]) => !omit.has(k) && v != null)
      .forEach(([k, v], idx) => {
        filas.push(pushPar(k, v, `extra-${idx}`));
      });
    if (!filas.length) {
      filas.push(
        <tr key="sin-resp">
          <td className="text-muted">Respuestas</td>
          <td>No hay respuestas</td>
        </tr>
      );
    }
    return (
      <div className="border rounded p-2">
        <table className="table table-sm table-bordered mb-0">
          <tbody>{filas}</tbody>
        </table>
      </div>
    );
  };
  

  const ordenNiveles = ['Basico', 'Intermedio', 'Avanzado'];
  const enRango = (ev) => {
    const d = ev?.createdAt?.toDate ? ev.createdAt.toDate() : new Date(ev?.createdAt);
    if (fechaDesde) {
      const from = new Date(fechaDesde);
      if (d < new Date(from.getFullYear(), from.getMonth(), from.getDate())) return false;
    }
    if (fechaHasta) {
      const to = new Date(fechaHasta);
      // incluir todo el día de fechaHasta
      const end = new Date(to.getFullYear(), to.getMonth(), to.getDate(), 23, 59, 59, 999);
      if (d > end) return false;
    }
    return true;
  };
  const evaluacionesFiltradas = evaluaciones.filter(enRango);
  const nivelesValidos = Array.from(new Set(evaluacionesFiltradas.map(e => e.nivel)))
    .filter(n => ordenNiveles.includes(n))
    .sort((a,b) => ordenNiveles.indexOf(a) - ordenNiveles.indexOf(b));

  const formatFecha = (ev) => {
    try {
      const d = ev?.createdAt?.toDate ? ev.createdAt.toDate() : new Date(ev?.createdAt);
      return isNaN(d) ? '' : d.toLocaleString();
    } catch { return ''; }
  };

  return (
    <Container>
      <NavbarGlobal title="Registro de Prácticas" showBackButton={true} />
      <Form className="mb-3">
        <Row className="g-3 align-items-end">
          <Col xs="12" md="4">
            <Form.Label>Módulo</Form.Label>
            <Form.Select value={filtroModulo} onChange={(e) => { setFiltroModulo(e.target.value); }}>
              <option value="">Todos</option>
              {Array.from(new Set(evaluaciones.map(e => e.modulo))).filter(Boolean).sort((a,b)=>Number(a)-Number(b)).map(m => (
                <option key={m} value={m}>{`Módulo ${m}`}</option>
              ))}
            </Form.Select>
          </Col>
          <Col xs="12" sm="6" md="4">
            <Form.Label>Desde</Form.Label>
            <Form.Control type="date" value={fechaDesde} onChange={(e) => setFechaDesde(e.target.value)} />
          </Col>
          <Col xs="12" sm="6" md="4">
            <Form.Label>Hasta</Form.Label>
            <Form.Control type="date" value={fechaHasta} onChange={(e) => setFechaHasta(e.target.value)} />
          </Col>
          <Col xs="12">
            <Form.Check
              type="switch"
              id="mostrar-sin-nivel"
              label="Mostrar ejercicios sin nivel"
              checked={mostrarSinNivel}
              onChange={(e) => setMostrarSinNivel(e.target.checked)}
            />
          </Col>
          <Col xs="12">
            <Button variant="outline-secondary" onClick={() => { setFiltroModulo(''); setFechaDesde(''); setFechaHasta(''); setMostrarSinNivel(false); setKey(''); }}>
              Limpiar filtros
            </Button>
          </Col>
        </Row>
      </Form>
      <Tabs id="controlled-tab-example" activeKey={key} onSelect={(k) => setKey(k || '')} className="mb-3">
        {nivelesValidos.map(nivel => {
          const porNombre = evaluacionesFiltradas
            .filter(e => e.nivel === nivel)
            .filter(e => !filtroModulo || e.modulo === filtroModulo)
            .reduce((acc, ev) => {
              const nombre = ev?.nombre || 'Ejercicio';
              (acc[nombre] = acc[nombre] || []).push(ev);
              return acc;
            }, {});
          const nombres = Object.keys(porNombre);
          return (
            <Tab eventKey={nivel} title={`Nivel  ${nivel}`} key={nivel}>
              <ListGroup variant="flush">
                {nombres.map((nombre, idx) => {
                  const items = porNombre[nombre].sort((a,b) => {
                    const da = a?.createdAt?.toDate ? a.createdAt.toDate() : new Date(a?.createdAt);
                    const db_ = b?.createdAt?.toDate ? b.createdAt.toDate() : new Date(b?.createdAt);
                    return (db_?.getTime?.()||0) - (da?.getTime?.()||0);
                  });
                  const titulo = (() => {
                    const n = items[0]?.nombre || '';
                    const idxSep = n.indexOf(':');
                    return idxSep >= 0 ? n.slice(idxSep + 1).trim() : '';
                  })();
                  const ejercicioNum = (() => {
                    const m = /Ejercicio\s+(\d+)/i.exec(items[0]?.nombre || '');
                    return m ? m[1] : '';
                  })();
                  return (
                    <ListGroupItem key={`${nivel}-${nombre}`} className="d-flex justify-content-between align-items-center">
                      <div className="d-flex flex-column">
                        <span className="fw-semibold">{`Módulo ${items[0]?.modulo || '—'} - ${ejercicioNum ? `Ejercicio ${ejercicioNum}` : 'Ejercicio'}`}</span>
                        {titulo && <small className="text-muted">{titulo}</small>}
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <Badge bg="secondary">{items.length}</Badge>
                        <Button
                          as={Link}
                          to={`/dashboard/listado-alumnos/registro-de-practicas/${id}/ejercicio?nivel=${nivel}&modulo=${items[0]?.modulo || ''}&nombre=${encodeURIComponent(items[0]?.nombre || '')}`}
                          size="sm"
                          variant="outline-primary"
                        >
                          Ver intentos
                        </Button>
                      </div>
                    </ListGroupItem>
                  );
                })}
                {nombres.length === 0 && (
                  <ListGroupItem>No hay ejercicios registrados para este nivel.</ListGroupItem>
                )}
              </ListGroup>
            </Tab>
          );
        })}
        {mostrarSinNivel && (
          <Tab eventKey="otros" title="Otros">
            <Accordion alwaysOpen>
              {(() => {
                const otros = evaluacionesFiltradas.filter(e => !ordenNiveles.includes(e?.nivel));
                const porNombre = otros.reduce((acc, ev) => {
                  const nombre = ev?.nombre || 'Ejercicio';
                  (acc[nombre] = acc[nombre] || []).push(ev);
                  return acc;
                }, {});
                const nombres = Object.keys(porNombre);
                return nombres.length ? nombres.map((nombre, idx) => {
                  const items = porNombre[nombre].sort((a,b) => {
                    const da = a?.createdAt?.toDate ? a.createdAt.toDate() : new Date(a?.createdAt);
                    const db_ = b?.createdAt?.toDate ? b.createdAt.toDate() : new Date(b?.createdAt);
                    return (db_?.getTime?.()||0) - (da?.getTime?.()||0);
                  });
                  return (
                    <Accordion.Item eventKey={`otros-${idx}`} key={`otros-${nombre}`}>
                      <Accordion.Header>
                        <span className="me-2">{nombre}</span>
                        <Badge bg="secondary">{items.length}</Badge>
                      </Accordion.Header>
                      <Accordion.Body>
                        <ListGroup variant="flush">
                          {items.map(ev => (
                            <ListGroupItem key={ev.id} className="d-flex justify-content-between align-items-start">
                              <div>
                                <div className="fw-semibold">{formatFecha(ev)}</div>
                                <div className="small text-muted">
                                  {ev?.tipo ? `Tipo: ${ev.tipo}` : ''}
                                  {ev?.pregunta ? ` • Pregunta: ${ev.pregunta}` : ''}
                                  {ev?.nivel ? ` • Nivel: ${ev.nivel}` : ' • Nivel: (sin nivel)'}
                                </div>
                                <div className="mt-2">{renderRespuestasTable(ev)}</div>
                              </div>
                              <div className="ms-3">
                                <Button as="a" href={`/cuaderno-digital`} target="_blank" rel="noopener noreferrer" size="sm" variant="outline-primary">
                                  Ir al ejercicio
                                </Button>
                              </div>
                            </ListGroupItem>
                          ))}
                        </ListGroup>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                }) : <ListGroup className="mt-2"><ListGroupItem>No hay ejercicios sin nivel.</ListGroupItem></ListGroup>;
              })()}
            </Accordion>
          </Tab>
        )}
      </Tabs>
    </Container>
  );
};

export { RegistroDePracticas };
